module.exports = __webpack_public_path__ + "static/allergy1-0e0d73dcb304743fe38b3fd420619aaa.png";